<ng-container *ngIf="usePopover">
  <div style="padding: 8px;">
    <ion-input
      fill="outline"
      labelPlacement="stacked"
      #searchbar
      [debounce]="250"
      (ionInput)="searchbarInput($event)"
    >
    <ion-label slot="label" style="font-weight: bold;">{{title}}</ion-label>
  </ion-input>
  </div>
  <ion-progress-bar *ngIf="isLoading" color="primary" type="indeterminate"></ion-progress-bar>
  <ion-list style="padding: 4px;" id="modal-list">
    <ion-item *ngIf="showCreateNewItem" class="ion-text-center" (click)="addNewItem()" style="cursor: pointer;">
      Add new item
    </ion-item>
    <ion-item *ngFor="let item of filteredItems; trackBy: trackItems">
      <ion-checkbox
        [value]="item"
        [checked]="isChecked(item.id)"
        (ionChange)="checkboxChange($event)"
        >{{ item.name || item.displayName }}</ion-checkbox
      >
    </ion-item>
  </ion-list>
</ng-container>
<ng-container *ngIf="!usePopover">
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="cancelChanges()">Cancel</ion-button>
      </ion-buttons>
      <ion-title class="ion-text-center">{{ title }}</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="confirmChanges()">Done</ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-toolbar>
      <ion-searchbar
        #searchbar
        mode="ios"
        [debounce]="250"
        (ionInput)="searchbarInput($event)"
      ></ion-searchbar>
    </ion-toolbar>
  </ion-header>
  
  <ion-content color="light" class="ion-padding" style="height: 100vh">
    <ion-list id="modal-list" [inset]="true">
      <ion-item *ngFor="let item of filteredItems; trackBy: trackItems">
        <ion-checkbox
          [value]="item"
          [checked]="isChecked(item.id)"
          (ionChange)="checkboxChange($event)"
          >{{ item.name || item.displayName }}</ion-checkbox
        >
      </ion-item>
    </ion-list>
  </ion-content>
</ng-container>
